import React from 'react';
import BundleEditView from './BundleEditView';
import BundleGridView from './BundleGridView';
import { Typography, Stack, Box, Button, Dialog, DialogContent } from '@mui/material';
import * as BundleApi from './BundleApi';
import { useHistory } from 'react-router-dom';
import ModalDialogTitle from 'Components/ModalDialogTitle';
import AddIcon from '@mui/icons-material/Add';

import { BundleContext } from './BundleContext';

export default function BundleBrowseView({ onBudnleSelected = () => {} }) {
    const [showAddModal, setShowAddModal] = React.useState(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(false);
    const { bundleList, setBundleList } = React.useContext(BundleContext)
    

    function addClicked() {
        setShowAddModal(true);
    }

    function addFormClosed(bundle) {
        setShowAddModal(false);
        if (bundle?.id) { editBundle(bundle.id) }
    }

    const loadBundles = React.useCallback(async () => {
        setIsLoading(true);
        const data = await BundleApi.getBundleList() || [];
        setBundleList(data);
        setIsLoading(false);
    }, [setBundleList]);

    React.useEffect(() => {
        (async () => {
            loadBundles()
        })();
    }, [loadBundles]);

    function editBundle(bundleId) {
        history.push('/bundles/' + bundleId);
    }

    function onBundleSelected(bundleId) {
        editBundle(bundleId)
    }

    function onArchiveBundle(bundle) {
        (async () => {
            await BundleApi.archiveBundle(bundle);
            await loadBundles();
        })();
    }

    function onBundleUpdated(bundle) {
        (async () => {
                addFormClosed(bundle);
        })();
    }

    return (
        <>
            <Dialog open={showAddModal} onClose={addFormClosed} fullWidth maxWidth="lg">
                <ModalDialogTitle onClose={addFormClosed}>&nbsp;</ModalDialogTitle>
                <DialogContent style={{ minHeight: '80vh', display: 'flex', flex: 1, maxHeight: '80vh' }}>
                    <BundleEditView bundle={{}} onBundleUpdated={onBundleUpdated} onClose={addFormClosed} />
                </DialogContent>
            </Dialog>
            <Stack direction="column" sx={{  flex : 1 }}>
                <Stack direction="row" justifyContent="space-between">
                    {/* onChange={onSearchTextChange} value={filter} onKeyUp={searchKeyHandler}  */}
                    <Box sx={{ width: '300px' }}>
                        <Typography variant="h1">Bundles</Typography>
                    </Box>
                    <Button variant="contained" onClick={addClicked} sx={{ fontWeight : 'bold', alignSelf: 'center' }} startIcon={<AddIcon/>}>
                        Add New
                    </Button>
                </Stack>
                <Box sx={{ height: '100%', flex: 1, display: 'flex' }}>
                    <BundleGridView
                        isLoading={isLoading}
                        bundleList={bundleList}
                        onBundleSelected={onBundleSelected}
                        onArchiveBundle={onArchiveBundle}
                    />
                </Box>
            </Stack>
        </>
    );
}
